import { render, staticRenderFns } from "./OrderReview.vue?vue&type=template&id=44e2aae3"
import script from "./OrderReview.vue?vue&type=script&lang=js"
export * from "./OrderReview.vue?vue&type=script&lang=js"
import style0 from "./OrderReview.vue?vue&type=style&index=0&id=44e2aae3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports